module.exports = __webpack_public_path__ + "img/gift2-tablet.3c1f0c8f.png";